
import { Component, Prop, Vue } from "vue-property-decorator";
import { VueLanguageMixin } from "../lib/language-ui";
import { Payment } from "../domain/types";

@Component
export default class ContactText extends Vue {
  @Prop() payment!: Payment;
  @Prop() cssColor!: string;

  get lang() {
    return (this.$root as VueLanguageMixin).lang;
  }
}
